import * as _ from 'lodash';

/**
 * @typedef { import('../objects/Attachment').AttachmentInfo } AttachmentInfo
 * @typedef { import('../directives/ergoFileInput').FileResult } FileResult
 */

function dataUrlToBase64(dataurl) {
    let pos = dataurl.indexOf(';base64,');
    if (pos < 0) throw new Error('base64 tag not found');
    return dataurl.substring(pos + 8);
}

export class PersonPhotoManager {

    constructor(photo) {
        if (photo != null) {
            this._existingPhoto = photo.info;
            this._existingPhotoDataUrl = photo.data;
        } else {
            this._existingPhoto = null;
            this._existingPhotoDataUrl = null;
        }

        /** @type {FileResult} */
        this._newPhoto = null;
        this._shouldRemovePhoto = false;
    }

    hasChanges() {
        return this._newPhoto != null || this._shouldRemovePhoto;
    }

    createUpdate() {
        if (this._shouldRemovePhoto) {
            return ({ Delete: true }); 
        } else if (this._newPhoto != null) {
            return ({
                Filename: this._newPhoto.name,
                Data: dataUrlToBase64(this._newPhoto.data),
            });
        }
    }

    canRemovePhoto() {
        return this._existingPhoto != null && this._newPhoto == null && !this._shouldRemovePhoto;
    }

    removePhoto() {
        if (!this.canRemovePhoto()) return;
        this._shouldRemovePhoto = true;
    }

    canRevertPhoto() {
        return this._newPhoto != null || this._shouldRemovePhoto;
    }

    revertPhoto() {
        if (!this.canRevertPhoto()) return;

        this._newPhoto = null;
        this._shouldRemovePhoto = false;
    }

    hasPhoto() {
        return this._newPhoto != null || (this._existingPhoto != null && !this._shouldRemovePhoto);
    }

    photoDataUrl() {
        if (this._newPhoto != null) {
            return this._newPhoto.data;
        } else if (this._existingPhoto != null && !this._shouldRemovePhoto) {
            return this._existingPhotoDataUrl;
        }
    }

    /**
     * @param {FileResult[]} files
     */
    setPhoto(files) {
        if (files && files.length > 0) {
            this._newPhoto = files[0];
            this._shouldRemovePhoto = false;
        }
    }
}